// extracted by mini-css-extract-plugin
module.exports = {"description-item":"index_description-item__dQ3wT","title":"index_title__1IOVs","content":"index_content__3wTAk","icon":"index_icon__HXSgS","icon-edit":"index_icon-edit__2hLVS"};